module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "component-selector"
  }, [_vm._m(0), _vm._v(" "), _c('list-view', {
    staticClass: "component-container"
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      staticClass: "component",
      attrs: {
        "selected": option.selected
      },
      on: {
        "click": function($event) {
          _vm.componentSelected(option.id)
        }
      }
    }, [_c('div', {
      staticClass: "component-image"
    }, [(option.id) ? _c('i', {
      class: 'icon-' + option.id
    }) : _vm._e(), _vm._v(" "), (!option.id) ? _c('div', {
      staticClass: "empty-placeholder"
    }) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v(_vm._s(option.name))]), _vm._v(" "), (option.dimension) ? _c('div', {
      staticClass: "component-dimension"
    }, [_c('div', [_vm._v(_vm._s(option.dimension.depth) + "mm 長")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(option.dimension.width) + "mm 寬")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(option.dimension.height) + "mm 高")])]) : _vm._e(), _vm._v(" "), (option.price) ? _c('div', [_c('span', {
      staticClass: "price-unit"
    }, [_vm._v("NT$")]), _vm._v(" " + _vm._s(_vm._f("priceTag")(option.price)))]) : _vm._e()])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "component-header"
  }, [_c('span', [_vm._v("造型")]), _vm._v(" "), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54823754!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-selector.vue
// module id = 198
// module chunks = 5